import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { ApplicationState } from "../applicationState";

export interface CreateGPSpecialistInfo {
    readonly name: string;
    readonly surgeryName: string;
    readonly surgeryAddressAndPostcode: string;
    readonly telephoneNumber: string;
    readonly emailAddress: string;
    readonly type?: GPSpecialistInfoType;
};

export interface GPSpecialistInfo extends CreateGPSpecialistInfo {
    readonly id?: string;
};

export interface EditGPSpecialistInfo extends GPSpecialistInfo { };

export interface GPSpecialistInfoListModel extends GPSpecialistInfo { };

export enum GPSpecialistInfoType {
    GP = "GP",
    Specialist = "Specialist"
}

export const GPSpecialistInfoTypeOptions = (Object.keys(GPSpecialistInfoType) as (keyof typeof GPSpecialistInfoType)[]).map(key => {
    return {
        text: GPSpecialistInfoType[key],
        value: key
    };
});

export const isCreateModelValid = (createModel: CreateGPSpecialistInfo) => {
    return !!createModel.name && !!createModel.surgeryName && !!createModel.type;
};

export const isEditModelValid = (editModel: EditGPSpecialistInfo) => isCreateModelValid(editModel);

export const gpSpecialistInfoIdSelector = (state: ApplicationState) => state.router.params.gpSpecialistInfoId;

export interface WriteToGPSpecialistModel {
    gpSpecialistId: string;
    notes: string;
};

export interface SendLetterToGPSpecialistModel {
    letterSentDetails: string;
};

export interface GPSpecialistLetterModel {
    gpSpecialistName: string;
    gpSpecialistAddress: string;
    letterDate: Date;
    customerTelephoneNumber: string;
    customerEmailAddress: string;
    customerCategory: string;
    employeePersonalReferenceNumber: string;
    employeeName: string;
    employeeDateOfBirth: string;
    employeeAddress: string;
    letterText: string;
    adminUserName: string;
    adminUserQualification: string;
}

export const parseGPSpecialistLetterModel = (model: ServerModelWithDateStrings<GPSpecialistLetterModel>): GPSpecialistLetterModel => {
    return {
        ...model,
        letterDate: isNaN(Date.parse(model.letterDate)) ? null : new Date(model.letterDate)
    };
};
